import {
  AccountSummaryChartType,
  AccountSummaryChartTypes,
  BarLabelPosition,
  EReportTargetComparisonOperators
} from '@opengov/reporting-types';

export const STACKING_CHART_TYPES: AccountSummaryChartType[] = [
  AccountSummaryChartTypes.Bar,
  AccountSummaryChartTypes.HorizontalBar
];

export const CHART_TYPES_WITH_TARGET_LINES: AccountSummaryChartType[] = [
  AccountSummaryChartTypes.Bar,
  AccountSummaryChartTypes.HorizontalBar,
  AccountSummaryChartTypes.Line
];

export const TARGET_CONDITIONS_WITH_SINGLE_AMOUNT: EReportTargetComparisonOperators[] = [
  EReportTargetComparisonOperators.greaterThan,
  EReportTargetComparisonOperators.greaterThanOrEqualTo,
  EReportTargetComparisonOperators.lessThan,
  EReportTargetComparisonOperators.lessThanOrEqualTo,
  EReportTargetComparisonOperators.equalTo,
  EReportTargetComparisonOperators.notEqualTo
];

// A target line plus one additional status, matching the classic Chart & Details target modal.
export const MAX_TARGET_CONDITIONS = 2;

// Only the ordering operators can express a narrower band inside the first condition, so they are
// the only ones offering an additional status. `between` already consumes both amounts, and
// `equalTo`/`notEqualTo` leave nothing to narrow — classic excludes those two for the same reason.
export const TARGET_CONDITIONS_WITH_ADDITIONAL_STATUS: EReportTargetComparisonOperators[] = [
  EReportTargetComparisonOperators.greaterThan,
  EReportTargetComparisonOperators.greaterThanOrEqualTo,
  EReportTargetComparisonOperators.lessThan,
  EReportTargetComparisonOperators.lessThanOrEqualTo
];

export const TARGET_CONDITIONS_EXPECTING_LOWER_ADDITIONAL_AMOUNT: EReportTargetComparisonOperators[] = [
  EReportTargetComparisonOperators.greaterThan,
  EReportTargetComparisonOperators.greaterThanOrEqualTo
];

export const ADDITIONAL_AMOUNT_TOO_HIGH_ERROR = 'This value must be lower than the first';
export const ADDITIONAL_AMOUNT_TOO_LOW_ERROR = 'This value must be greater than the first';

export const CHART_TYPE_SERIES_LABELS: Record<Exclude<AccountSummaryChartType, null> | 'default', string> = {
  bar: 'Bars',
  line: 'Lines',
  horizontalBar: 'Bars',
  pie: 'Category',
  donut: 'Category',
  gauge: '', // Not used
  default: 'Series'
};

export const CHART_TYPE_CATEGORIES_LABELS: Record<Exclude<AccountSummaryChartType, null> | 'default', string> = {
  bar: 'X Axis Categories',
  line: 'X Axis Categories',
  horizontalBar: 'Y Axis Categories',
  pie: 'Slices',
  donut: 'Arcs',
  gauge: '', // Not used
  default: 'Categories'
};

export const CHART_TYPE_SOURCE_LABELS: Record<Exclude<AccountSummaryChartType, null> | 'default', string> = {
  bar: 'X Axis Source',
  line: 'X Axis Source',
  horizontalBar: 'Y Axis Source',
  pie: 'Pie Source',
  donut: 'Donut Source',
  gauge: 'Gauge Source',
  default: 'Source'
};

export const TARGET_CONDITION_OPTIONS = [
  {
    value: EReportTargetComparisonOperators.between,
    label: 'Between'
  },
  {
    value: EReportTargetComparisonOperators.greaterThan,
    label: 'Greater Than'
  },
  {
    value: EReportTargetComparisonOperators.greaterThanOrEqualTo,
    label: 'Greater Than or Equal To'
  },
  {
    value: EReportTargetComparisonOperators.lessThan,
    label: 'Less Than'
  },
  {
    value: EReportTargetComparisonOperators.lessThanOrEqualTo,
    label: 'Less Than or Equal To'
  },
  {
    value: EReportTargetComparisonOperators.equalTo,
    label: 'Equal To'
  },
  {
    value: EReportTargetComparisonOperators.notEqualTo,
    label: 'Not Equal To'
  }
] as const;

// left → bottom, center → middle, right → top
export const BAR_LABEL_POSITION_MAP: Record<BarLabelPosition, BarLabelPosition> = {
  top: 'top',
  middle: 'middle',
  bottom: 'bottom',
  left: 'bottom',
  center: 'middle',
  right: 'top'
};

// top → right, middle → center, bottom → left
export const HORIZONTAL_BAR_LABEL_POSITION_MAP: Record<BarLabelPosition, BarLabelPosition> = {
  top: 'right',
  middle: 'center',
  bottom: 'left',
  left: 'left',
  center: 'center',
  right: 'right'
};

export const CHART_TYPES_WITH_MULTIPLE_Y_AXIS_SUPPORT: AccountSummaryChartType[] = [
  AccountSummaryChartTypes.Bar,
  AccountSummaryChartTypes.Line
];
